import { render, staticRenderFns } from "./customerInformationDetail.vue?vue&type=template&id=3ba525bc&scoped=true&"
import script from "./customerInformationDetail.vue?vue&type=script&lang=js&"
export * from "./customerInformationDetail.vue?vue&type=script&lang=js&"
import style0 from "./customerInformationDetail.vue?vue&type=style&index=0&id=3ba525bc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba525bc",
  null
  
)

export default component.exports